import Vue from 'vue'
import VueRouter from 'vue-router'
// import HomeView from '../views/HomeView.vue'
import SettingsView from '../views/SettingsView.vue'
import GameView from '../views/GameView.vue'
import ResultView from '../views/ResultView.vue'
import ResultViewNew from '../views/ResultViewNew.vue'
import PageNotFoundView from '../views/PageNotFoundView.vue'
import PlayerHistory from "../views/PlayerHistory.vue"
import LeagueGameStart from "../views/LeagueGameStart.vue"


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    redirect: '/settings',
  },
  {
    path: '/settings',
    name: 'settings',
    component: SettingsView
  },
  {
    path: '/game/:gameType/:gameId',
    name: 'game',
    component: GameView
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/result/:gameType/:gameId',
    name: 'result',
    component: ResultView
  },
  {
    path: '/resultnew/:gameType/:gameId',
    name: 'resultnew',
    component: ResultViewNew
  },
  {
    path: "/player-history",
    name: "playerHistory",
    component: PlayerHistory
  },
  {
    path: "/league-game-start",
    name: "leagueGameStart",
    component: LeagueGameStart
  },
  {
    path: "/*",
    name: 'pageNotFound',
    component: PageNotFoundView,
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
